export default {
  search: 'Search',
  userAccessFor: 'User access for:',
  save: 'Save',
  warning: 'Warning',
  cannotBeUndone: 'This action cannot be undone. Are you sure?',
  abort: 'Abort',
  confirm: 'Confirm',
  processing: 'Processing...',
  email: 'Email',
  name: 'Name',
  users: 'Users'
}
